module.exports = __webpack_public_path__ + "static/img/benner.153e399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/culture/benner.png
// module id = Hrd/
// module chunks = 1